


































































































import { Component, Vue } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
import { PostRegister } from "@/request/common";
import Remember from "../components/remember.vue";
import { Md5 } from "ts-md5";
@Component({
  components: {
    Remember,
  },
})
export default class Login extends Vue {
  private type: any = "text";
  private ifRember: any = true;
  private info: any = {
    username: "",
    password: "",
  };
  private repeatPaw:any='';

  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private gologin() {
    
    this.$router.push("/access/login");
  }
  /**
   * @description  
   */
  private register(): void {
    if (!this.info["username"]) {
      this.$message.warning("请输入用户名");
      return;
    }
    if (!this.info["password"]) {
      this.$message.warning("请输入密码");
      return;
    }
    if (!this.repeatPaw) {
      this.$message.warning("请重复输入密码");
      return;
    }
    if (this.info["password"] != this.repeatPaw) {
      this.$message.warning("2次密码输入不一致");
      return;
    }
    // if (!this.ifRember) {
    //   this.$message.warning("请先阅读用户协议和隐私政策");
    //   return;
    // }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostRegister(this, this.info, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("注册成功");
        this.gologin();
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {}
}
